export default __webpack_public_path__ + "static/media/filter-close.73399cf8.svg";